import { IRevenueAgencyFakeTypeLang } from '../../../types/lang'
import { ERevenueAgencyFakeType } from '../../../types'

export const revenueAgencyFakeTypeLang: IRevenueAgencyFakeTypeLang = {
	revenue_agency_fake_type: {
		[ERevenueAgencyFakeType.None]: 'None',
		[ERevenueAgencyFakeType.AccountFB]: 'AccountFB',
		[ERevenueAgencyFakeType.Creo]: 'Creo',
		[ERevenueAgencyFakeType.Installs]: 'Installs',
		[ERevenueAgencyFakeType.Slices]: 'Slices'
	}
}